import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { gitVersion } from 'src/environments/git-version';

@Component({
    standalone: false,
    selector: 'app-version-information',
    templateUrl: './version-information.component.html',
    styleUrls: ['./version-information.component.scss']
})
export class VersionInformationComponent {
    readonly version = environment.appVersion;

    get gitVersion() {
        return gitVersion;
    }
}
